// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"wrapper___GN1w1","linksWrapper":"linksWrapper___qh3LO","link":"link___4pglh","tooltip":"tooltip___2iNv2"};